import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {getImageSrc} from 'app/utilities/ImageProps';
import DefaultEquipmentIcon from "./assets/defaultEquipmentIcon.svg";

const EquipmentSection = ({disconnectedServicesAndEquipments,setShowEquipment, context}) => {
    const {services, loanedEquipmentKitsWithoutAService} = disconnectedServicesAndEquipments;

    return ( 
        <div className='equipment-section'>
            <button className='equipment-section__close-btn' onClick={() => setShowEquipment(prevState => !prevState)}>X</button>
            <div className='equipment-section__holder'>
                <header className='equipment-section__title'>רשימת הציוד שברשותך להחזרה</header>
                {services.map((service, idx) => {
                    return service.loanedEquipmentKits?.length > 0 ? 
                    <ServiceKit service={service} context={context} key={`${idx}_${service.family}`} /> :
                    "";
                })}
                {loanedEquipmentKitsWithoutAService.length > 0 ? <KitsWithoutAService kitsWithoutAService={loanedEquipmentKitsWithoutAService} /> : ""}
            </div>
        </div>
     );
}

function KitsWithoutAService({kitsWithoutAService, context}) {
    let component = "";
    
    try {
       component = <div className='equipment-section__service-kit'>
                        <label className='equipment-section__service-title'>ציוד נוסף</label>
                        {kitsWithoutAService.map(kit => {
                            return kit.kitItems.map(item => {
                                return <Item item={item} context={context} key={item.id}/>
                            });
                        })}
                    </div>
    }
    catch(ex) {
        console.log(`EquipmentSection => KitsWithoutAService EXCEPTION :: ${ex}`);
        component = "";
    }

    return component;
}

function ServiceKit({service, context}) {
    let component = "";
    try {
       component = <div className='equipment-section__service-kit'>
                        {service.loanedEquipmentKits.map((servicekit, idx) => {
                            return <React.Fragment key={idx}>
                                        <label className='equipment-section__service-title'>{`עבור ${servicekit.baseItem} יש להחזיר:`}</label>
                                        {servicekit.kitItems.map(item => {
                                             return <Item item={item} context={context} key={item.id}/>
                                        })}
                                    </React.Fragment> })}
                    </div>
    }
    catch(ex) {
        console.log(`EquipmentSection => ServiceKit EXCEPTION :: ${ex}`);
        component = "";
    }

    return component;
}

function Item({item, context}) {
    let component = "";
    let imgSrc = DefaultEquipmentIcon;
    const equipMsg = getImageSrc(item.smallImageUrl, context);
    if(equipMsg) {
        imgSrc = equipMsg;
    }
    const showPrice = item.itemCostWithVAT !== "0" && item.itemCostWithVAT !== "0.0" && item.itemCostWithVAT !== "0.00"
     && item.itemCostWithVAT !== "" && item.itemCostWithVAT;
    try {
       component = <div className='equipment-section__item'>
                        <Image src={imgSrc} alt='ציוד' />
                        <div className='equipment-section__item-description-holder'>
                            <span className='equipment-section__item-description'>{item.description}</span>
                            {showPrice && <span className='equipment-section__item-price'>{item.itemCostWithVAT} ש"ח</span>}
                        </div>
                    </div>
    }
    catch(ex) {
        console.log(`EquipmentSection => Item EXCEPTION :: ${ex}`);
        component = "";
    }

    return component;
}


 
export default EquipmentSection;